// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"311":"2e460d39","726":"34034589","787":"5f87238e"}[chunkId] + ".chunk.js";
};